// React Thirty Party Library
import { Form, message } from "antd";
import { useSelector, useDispatch } from "react-redux";

// Handler Library

// Services Library
import { REDUX as REDUX_UTIL } from "../../../../../../services/util";

// Redux Actions
import * as REDUX_ACTION from "../../../../../../services/redux/actions";

import DrawerFormGroup from "../DrawerFormGroup";

const { reduxStoreWrapper } = REDUX_UTIL

const DrawerAddGroup = (props) => {
  const { isOpen, setIsOpen } = props;

  const dispatch = useDispatch();

  const [messageApi, contextHolder] = message.useMessage();
  
  const [form] = Form.useForm();

  const user = useSelector(reduxStoreWrapper("user"));
  
  const createGroup = () => {
    form
      .validateFields()
      .then(() => {
        const formData = form.getFieldValue()
        const name = formData.groupName
        const color = formData.groupColor

        messageApi.open({
          type: "loading",
          content: "Create Group...",
          duration: 0,
        });

        dispatch(
          REDUX_ACTION.v1_group.create_group({
            coid: user.coid,
            name: name, 
            color: color,
          }, () => {
            messageApi.destroy();
          })
        );

      })
      .catch(() => {
        message.error("fill the form");
      });
  };

  return (
    <>
    {contextHolder}
    <DrawerFormGroup
        form={form}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        type="add"
        handleSave={createGroup}
    />
    </>
  );
};

export default DrawerAddGroup;
